// ══════════════════════════════════════════════════════════
// DEFINICIÓN DE LAS 10 CLASES DE PEONZAS
// ══════════════════════════════════════════════════════════

export interface ClassDefinition {
  id: string;
  name: string;
  description: string;
  color: number;
  hp: number;
  attack: number;
  speed: number;       // velocidad angular
  defense: number;     // resistencia a knockback
  stability: number;   // resistencia a tambaleo
  density: number;     // masa / densidad
  specialPassive: string; // descripción breve de la pasiva única
}

export const CLASSES: ClassDefinition[] = [
  {
    id: 'equilibrado',
    name: 'Equilibrado',
    description: 'Stats equilibradas sin puntos débiles fuertes.',
    color: 0x95a5a6,
    hp: 100,
    attack: 10,
    speed: 1.5,
    defense: 1.0,
    stability: 1.0,
    density: 0.01,
    specialPassive: '—',
  },
  {
    id: 'tanque',
    name: 'Tanque',
    description: 'Alta defensa y HP. Reduce el knockback recibido.',
    color: 0x2c3e50,
    hp: 150,
    attack: 8,
    speed: 0.9,
    defense: 1.4,
    stability: 1.3,
    density: 0.015,
    specialPassive: 'Reduce knockback recibido un 20%.',
  },
  {
    id: 'asesino',
    name: 'Asesino',
    description: 'Alta velocidad y ataque. Golpes críticos potentes.',
    color: 0xe74c3c,
    hp: 70,
    attack: 15,
    speed: 2.1,
    defense: 0.7,
    stability: 0.7,
    density: 0.007,
    specialPassive: 'Golpes críticos con +30% velocidad relativa.',
  },
  {
    id: 'control',
    name: 'Control',
    description: 'Alta estabilidad. Empuja rivales con facilidad.',
    color: 0x9b59b6,
    hp: 110,
    attack: 9,
    speed: 1.5,
    defense: 1.2,
    stability: 1.5,
    density: 0.011,
    specialPassive: 'Empuje adicional en colisiones frontales.',
  },
  {
    id: 'vampiro',
    name: 'Vampiro',
    description: 'Recupera HP al dañar a los rivales.',
    color: 0x8e44ad,
    hp: 90,
    attack: 7,
    speed: 1.5,
    defense: 0.8,
    stability: 0.9,
    density: 0.009,
    specialPassive: 'Recupera 20% del daño infligido como HP.',
  },
  {
    id: 'magnetico',
    name: 'Magnético',
    description: 'Atrae peonzas cercanas, creando colisiones constantes.',
    color: 0x3498db,
    hp: 100,
    attack: 10,
    speed: 1.4,
    defense: 1.1,
    stability: 1.0,
    density: 0.012,
    specialPassive: 'Atrae peonzas en radio 100px.',
  },
  {
    id: 'ventoso',
    name: 'Ventoso',
    description: 'Alta velocidad. Desvía trayectorias rivales.',
    color: 0x1abc9c,
    hp: 80,
    attack: 12,
    speed: 2.2,
    defense: 0.8,
    stability: 0.8,
    density: 0.008,
    specialPassive: 'Empuje radial que desvía peonzas en 25px.',
  },
  {
    id: 'roca',
    name: 'Roca',
    description: 'Defensa y HP extremos. Casi imposible de mover.',
    color: 0x7f8c8d,
    hp: 200,
    attack: 6,
    speed: 0.8,
    defense: 1.6,
    stability: 1.5,
    density: 0.017,
    specialPassive: 'Inmutable: 90% reducción de knockback.',
  },
  {
    id: 'veneno',
    name: 'Veneno',
    description: 'Daño continuo a peonzas cercanas.',
    color: 0x27ae60,
    hp: 80,
    attack: 5,
    speed: 1.6,
    defense: 0.9,
    stability: 1.0,
    density: 0.009,
    specialPassive: 'Daño 3 HP/s a rivales en radio 60px.',
  },
  {
    id: 'elastico',
    name: 'Elástico',
    description: 'Rebota con más fuerza y devuelve empujones.',
    color: 0xe67e22,
    hp: 90,
    attack: 11,
    speed: 1.6,
    defense: 0.6,
    stability: 0.7,
    density: 0.008,
    specialPassive: 'Devuelve 40% del knockback recibido.',
  },
];
